<section class="news-detail" *ngIf="selectedNews; else noNews">

  <!-- HERO -->
  <header class="news-hero">
    <div class="news-hero__overlay"></div>

    <div class="news-hero__container">
      <span class="news-hero__category">
        {{ selectedNews.category.categoryName }}
      </span>

      <h1 class="news-hero__title">
        {{ selectedNews.newsTitle }}
      </h1>

      <div class="news-hero__meta">
        {{ transformDate(selectedNews.publicationDate) }}
      </div>
    </div>
  </header>

  <!-- IMAGE -->
  <section class="news-media">
    <img
      [src]="selectedNews.image.fileUUID
        ? imageBaseUrl + selectedNews.image.fileUUID
        : defaultImg"
      alt="News Image"
    />
  </section>

  <!-- CONTENT -->
  <article class="news-content">
    <div
      class="news-content__body"
      [innerHTML]="getSafeDescription(selectedNews.newsDescp)">
    </div>
  </article>

</section>

<ng-template #noNews>
  <div class="news-empty">
    <p>No news selected.</p>
  </div>
</ng-template>